import { NgModule } from '@angular/core';
import { ErrorCounterComponent } from './error-counter.component';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule
  ],
  declarations: [
    ErrorCounterComponent
  ],
  exports: [
    ErrorCounterComponent
  ]
})
export class ErrorCounterModule { }
